import React, { FormEvent, ReactElement } from 'react';
import { Button, Heading, LoaderButton } from 'idsk-react-components';
import { MultiFileUploader } from 'slovlex-idsk-react-components';
import { SafeParameterSetter } from '../../../model/types/SafeParameterSetter';
import PrispevokVestnika from '../../../model/PrispevokVestnika';
import PrispevokVestnikaStepEnum from '../../../model/PrispevokVestnikaStepEnum';
import CheckDataTable from '../component/CheckDataTable';
import PrilohaVestnika from '../../../model/PrilohaVestnika';
import scrollToTop from '../../../function/scrollToTop';
import { handleDownloadPriloha } from '../../../function/handleDownloadPriloha';
import { useSecurityContext } from '../../../context/SecurityContext';

interface Props {
  prispevokVestnika: PrispevokVestnika;
  onSubmit: (e: FormEvent<HTMLFormElement>, activeStep: PrispevokVestnikaStepEnum) => void;
  onUpdateField: SafeParameterSetter<PrispevokVestnika>;
  loading: boolean;
  clearStatus: () => void;
  getFieldErrorMessage: (fieldName: string) => string | undefined;
  clearFieldErrorMessage?: (fieldName: string) => void;
  clearArrayFieldErrorMessage?: (fieldName: string) => void;
  isUpdate?: boolean;
  onChange: (nextStep: PrispevokVestnikaStepEnum) => Promise<void>;
}

const AttachmentsStep4 = ({
  onSubmit,
  onUpdateField,
  prispevokVestnika,
  loading,
  clearStatus,
  getFieldErrorMessage,
  clearFieldErrorMessage,
  clearArrayFieldErrorMessage,
  isUpdate = false,
  onChange,
}: Props): ReactElement => {
  const { accessToken, organizationId } = useSecurityContext();
  const headers = {
    ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
    ...(organizationId && { OrganizationId: encodeURIComponent(organizationId) }),
  };
  return (
    <div className="prispevok-vestnika-step-pages">
      <Heading className="page-title" size="xl">
        Nahrajte prílohy príspevku
      </Heading>
      <Heading size="m">Nahrajte súbor <span className="idsk-hint optional-message">(nepovinný údaj)</span></Heading>
      <MultiFileUploader
        maxInputLength={254}
        onDownload={handleDownloadPriloha}
        options={{ headers }}
        width="three-quarters"
        prilohaList={prispevokVestnika.prilohy}
        clearFieldErrorMessage={clearFieldErrorMessage}
        clearArrayFieldErrorMessage={clearArrayFieldErrorMessage}
        getFieldErrorMessage={getFieldErrorMessage}
        fieldName="priloha"
        onChange={(
          prilohaList: PrilohaVestnika[],
        ) => {
          onUpdateField('prilohy', prilohaList);
        }}
      />
      <LoaderButton
        loading={loading}
        type="submit"
        size="large"
        onClick={(e) => {
          if (prispevokVestnika.prilohy.length > 1) {
            onSubmit(e, PrispevokVestnikaStepEnum.MAIN_ATTACHMENT_5);
          } else {
            onSubmit(e, PrispevokVestnikaStepEnum.CHECK_DATA_6);
          }
        }}
      >{prispevokVestnika.prilohy.length > 1 ? 'Pokračovať' : 'Pokračovať na sumár príspevku'}
      </LoaderButton>
      <Button
        className="prispevok-vestnika-step-pages__back-button"
        type="button"
        buttonStyle="third"
        size="large"
        disabled={loading}
        onClick={() => {
          clearStatus();
          onUpdateField('activeStep', PrispevokVestnikaStepEnum.RELATED_DATA_3);
          scrollToTop();
        }}
      >
        Späť
      </Button>
      <Heading size="m">Vaše odpovede</Heading>
      <CheckDataTable
        prispevokVestnika={prispevokVestnika}
        onChange={onChange}
        isUpdate={isUpdate}
      />
    </div>
  );
};

export default AttachmentsStep4;
